document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-mtrx-add]');
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.mtrxAdd;
  if (!variantId) return;

  const originalHtml = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = '<span style="opacity:.5">…</span>';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    btn.innerHTML = '✓';
    btn.classList.add('mtrx-card__atc--added');

    const cart = await fetch('/cart.js').then(r => r.json());

    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });

    // Open Ella's cart sidebar and refresh its contents
    if (window.sharedFunctions?.updateSidebarCart) {
      window.sharedFunctions.updateSidebarCart(cart);
      document.body.classList.add('cart-sidebar-show');
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count } }));

    setTimeout(() => {
      btn.innerHTML = originalHtml;
      btn.disabled = false;
      btn.classList.remove('mtrx-card__atc--added');
    }, 1800);
  } catch {
    btn.innerHTML = originalHtml;
    btn.disabled = false;
  }
});
